/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuntimeRoundInfo,
    RuntimeRoundInfoFromJSON,
    RuntimeRoundInfoFromJSONTyped,
    RuntimeRoundInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface RuntimeRoundListResponse
 */
export interface RuntimeRoundListResponse {
    /**
     * 
     * @type {Array<RuntimeRoundInfo>}
     * @memberof RuntimeRoundListResponse
     */
    list: Array<RuntimeRoundInfo>;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundListResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundListResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundListResponse
     */
    totalSize?: number;
}

export function RuntimeRoundListResponseFromJSON(json: any): RuntimeRoundListResponse {
    return RuntimeRoundListResponseFromJSONTyped(json, false);
}

export function RuntimeRoundListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeRoundListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(RuntimeRoundInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function RuntimeRoundListResponseToJSON(value?: RuntimeRoundListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(RuntimeRoundInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


